import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LANGUAGE_STORAGE_KEY = 'selectedLanguage';
const DIRECTION_STORAGE_KEY = 'selectedDirection';

const DirectionManager = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const isAdmin = location.pathname.startsWith('/bj-admin');
    if (isAdmin) {
      // Force LTR in admin routes
      document.documentElement.dir = 'ltr';
      return;
    }

    // For non-admin routes, follow stored direction or infer from language
    const storedDir = localStorage.getItem(DIRECTION_STORAGE_KEY);
    const lang = localStorage.getItem(LANGUAGE_STORAGE_KEY) || i18n.language || 'en';
    const inferredDir = lang === 'ar' || lang?.toLowerCase().startsWith('ar') ? 'rtl' : 'ltr';
    document.documentElement.dir = storedDir || inferredDir;
  }, [location.pathname, i18n.language]);

  return null;
};

export default DirectionManager;

